import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { privacyPolicyService, PrivacyPolicyStatus } from '@services/privacy-policy/privacy-policy';

import Markup from '../markup/markup';
import { WOLFE_API } from '@root/config/endpoints';
import BoonButton from '../button/boon-button';

export const PrivacyPolicy: React.FC = () => {
    const { t } = useTranslation('privacy');
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        const privacyPolicyStatus = privacyPolicyService.getStatus();
        if (privacyPolicyStatus && privacyPolicyStatus === PrivacyPolicyStatus.ACCEPTED) {
            setShow(false);
            return;
        }
        setShow(true);
    }, []);

    return (
        <React.Fragment>
            {show && (
                <div className="PrivacyPolicy fixed bottom-0 w-full bg-boon-gray-privacy bg-opacity-80 py-6 px-4 z-50">
                    <div className="w-full flex flex-col lg:flex-row lg:mb-2">
                        <div className="flex flex-col justify-center lg:pr-2 lg:w-10/12">
                            <div>
                                <p className="text-center lg:text-right text-boon-brown-semidark base-text-size-p leading-tight mb-2 lg:mb-1">
                                    <Markup content={t('cookie-message')} />
                                </p>
                                <div className="text-center lg:text-right text-boon-brown-semidark base-text-size-7 leading-tight font-medium">
                                    <a
                                        className="ConsentFormLink underline mr-4"
                                        href={`${WOLFE_API}/consent-form`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t('consent-form')}
                                    </a>
                                    <a
                                        className="DataPrivacyLink underline"
                                        href={`${WOLFE_API}/data-privacy`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t('data-privacy')}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="flex lg:w-2/12 pt-6 lg:pt-0 justify-center">
                            <BoonButton
                                style="dark"
                                height="h-8 lg:h-16"
                                width="w-22 lg:w-32"
                                type="link"
                                onClick={() => {
                                    privacyPolicyService.acceptPolicy();
                                    setShow(false);
                                }}
                                font="base-text-size-8 lg:text-base text-white font-gr-book uppercase"
                            >
                                {t('i-accept-button')}
                            </BoonButton>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};
